import apiClient from '../index';

export const authApi = {
  // Register new user (Event)
  registerEvent: (userData) => apiClient.post('/auth/register', userData),

  // Register new Service Provider
  registerServiceProvider: (userData) => apiClient.post('/auth/register', userData),

  // Login user
  login: (credentials) => apiClient.post('/auth/login', credentials),

  // Logout user
  logout: () => apiClient.get('/auth/logout'),

  // Change password (for logged in users)
  changePassword: (passwordData) => apiClient.put('/password-change', {
    oldpassword: passwordData.oldpassword || passwordData.current_password,
    newpassword: passwordData.newpassword || passwordData.new_password
  }),

  // Public reset password
  resetPassword: (data) => {
    const payload = {
      authorization_code: data.authorization_code,
      new_password: data.new_password || data.newpassword
    };
    if (data.mobile || data.number || data.email) {
      payload.mobile = data.mobile || data.number || data.email;
      payload.number = data.mobile || data.number || data.email;
    }
    return apiClient.post('/password/reset', payload);
  },
  // Activation routes
  getActivationToken: (token) => apiClient.get(`/auth/activate/${token}`),
  activateAccount: (data) => apiClient.post('/auth/activate', data),
  // Request OTP for registration and password reset
  requestOtp: (data) => {
    const payload = { number: data.number };
    if (data.password_reset_request) {
      payload.password_reset_request = data.password_reset_request;
    }
    return apiClient.post('/auth/registration/request-otp', payload);
  },

  // Verify OTP
  verifyOtp: (data) => apiClient.post('/auth/registration/verify-otp', {
    otp: data.otp,
    number: data.number
  }),



  // Get user profile
  getProfile: (id) => apiClient.get(`/user/profile/${id}`),

  // Update user profile
  updateProfile: (id, userData) => apiClient.post(`/user/profile-update/${id}`, userData),

  // Request account deletion OTP
  requestDeleteOtp: (data) => apiClient.post('/user/account-delete-otp', data),

  // Verify and delete account
  deleteAccount: (data) => apiClient.post('/user/account-delete', data),

  // Alternate account deletion OTP (new route)
  requestDeleteAccountOtp: (data) => apiClient.post('/account-delete/request-otp', data),

  // Alternate verify and delete account (new route)
  verifyDeleteAccount: (data) => apiClient.post('/account-delete', data),
};

export default authApi;